import i18next, { i18n } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { canonicalLocales, getCanonicalLocale } from '~/i18n/helpers';

const LOCALISATION_NAMESPACES = process.env.LOCALISATION_NAMESPACES || [];

class I18Next {
  instance: i18n = i18next;
  isInitialized = false;
  public init(cb?: (detectedLang: string, platformLang: string) => void): void {
    if (!this.isInitialized) {
      this.instance
        .use(initReactI18next)
        .use(LanguageDetector)
        .use(HttpApi)
        .init(
          {
            supportedLngs: Object.keys(canonicalLocales),
            fallbackLng: { ...canonicalLocales, default: ['en'] },
            detection: {
              order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
              caches: ['localStorage'],
              lookupQuerystring: 'lang',
            },
            nsSeparator: ':',
            ns: LOCALISATION_NAMESPACES,
            maxParallelReads: 100,
            defaultNS: 'general',
            interpolation: {
              escapeValue: false,
            },
            backend: {},
          },
          () => {
            this.isInitialized = true;

            const detectedLang = this.instance.language;
            const platformLang = getCanonicalLocale(this.instance.language);

            if (detectedLang !== platformLang) {
              this.instance.changeLanguage(platformLang).then(() => {
                cb?.(detectedLang, platformLang);
              });
            }

            this.instance.on('languageChanged', (lang) => {
              const changedDetectedLang = this.instance.language;

              const newPlatformLang = getCanonicalLocale(lang);
              cb?.(changedDetectedLang, newPlatformLang);
            });
          },
        );
    }
  }

  public t = this.instance.t;
}

export default new I18Next();
